var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-container"},[_vm._v("\n  "+_vm._s(_vm.currentStep)+" מתוך "+_vm._s(_vm.totalNumberOfSteps)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }